import { cloneElement, isValidElement, type ReactElement, type ReactNode } from "react"

import { cn } from "@/utils/tailwind"

type SlotProps = React.HTMLAttributes<HTMLElement> & { children?: ReactNode; ref?: React.Ref<HTMLElement> }

/** Renders its only child element with the given props merged in (`asChild` pattern). Child props win, classes are joined. */
export function Slot({ children, className, ...props }: SlotProps) {
  if (!isValidElement(children)) return null

  const child = children as ReactElement<{ className?: string }>
  return cloneElement(child, { ...props, ...child.props, className: cn(className, child.props.className) })
}
